import { render, staticRenderFns } from "./linkBar.vue?vue&type=template&id=587852eb&scoped=true"
import script from "./linkBar.vue?vue&type=script&lang=js"
export * from "./linkBar.vue?vue&type=script&lang=js"
import style0 from "./linkBar.vue?vue&type=style&index=0&id=587852eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587852eb",
  null
  
)

export default component.exports